import { useEffect, useState } from "react";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";

import Form from "../../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import SwitchInput from "../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput";
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import { COLORS_API, PROMOTIONS_API } from "../../../../../Utilities/APIs/APIs";
import SelectInput from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";
import DateInput from "../../../../Partials/Layouts/Forms/FormInputs/DateInput/DateInput";

function UpdatePromotion({ targetID, triggerFetch, setShowUpdateForm }) {
  const axiosInstance = useAxiosInstance();

  const [promoCode, setPromoCode] = useState("");
  const [maxlimit, setMaxlimit] = useState(0);
  const [discountType, setDiscountType] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [promoType, setPromoType] = useState("");
  const [validStartDate, setValidStartDate] = useState("");
  const [validEndDate, setValidEndDate] = useState("");

 

   useEffect(() => {
      async function fetchAndSetSingleProductCollections() {
        const { data } = await axiosInstance.get(PROMOTIONS_API + 'getSinglePromotion/' + targetID)
        const sd = new Date(data?.validStartDate)
        const ed = new Date(data?.validEndDate)
        setPromoCode(data?.promoCode)
        setMaxlimit(data?.maxlimit)
        setDiscountType(data?.discountType)
        setDiscountAmount(data?.discountAmount)
        setPromoType(data?.promoType)
        setValidStartDate(`${sd.toISOString().slice(0, 10)}`)
        setValidEndDate(`${ed.toISOString().slice(0, 10)}`)
        
      }
      fetchAndSetSingleProductCollections()

    }, [targetID, axiosInstance])


  async function handleSubmit(e) {
    e.preventDefault();
    const itemData = {
      promoCode,
      maxlimit,
      discountType,
      discountAmount,
     promoType,
      validStartDate,
      validEndDate,
    };

    const response = await axiosInstance.patch(PROMOTIONS_API + targetID , itemData);
    if (response) {
      triggerFetch();
      setShowUpdateForm(false);
    }
  }

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div>
          <ShortTextInput
            label={`Promo Code`}
            value={promoCode}
            placeholder={`Enter Promo Code`}
            setState={setPromoCode}
          />
          <ShortTextInput
            label={`Maxlimit`}
            value={maxlimit}
            placeholder={`Enter Maxlimit`}
            setState={setMaxlimit}
          />
          
           <SelectInput
            label={`Discount Type`}
            value={discountType}
            setState={setDiscountType}
          >
            <SelectOption optionValue="" optionText="Select Discount Type" />
            <SelectOption optionValue="percentage" optionText="Percentage" />
            <SelectOption optionValue="amount" optionText="Amount" />
          </SelectInput>
          <ShortTextInput
            label={`Discount Amount`}
            value={discountAmount}
            placeholder={`Enter DiscountAmount`}
            setState={setDiscountAmount}
          />
           <SelectInput
            label={"Promo Type"}
            value={promoType}
            setState={setPromoType}
          >
            <SelectOption optionValue="" optionText="Select Promo type" />
            <SelectOption optionValue="unlimited" optionText="unlimited" />
            <SelectOption optionValue="oneTime" optionText="oneTime" />
          </SelectInput>
          <DateInput
            label={`ValidStart Date`}
            value={validStartDate}
            placeholder={`Enter ValidStart Date`}
            setState={setValidStartDate}
          />
          <DateInput
            label={`Valid EndDate`}
            value={validEndDate}
            placeholder={`Enter Valid EndDate`}
            setState={setValidEndDate}
          />
        </div>
        <FormSubmitButton text="Submit" />
      </Form>
    </div>
  );
}

export default UpdatePromotion;
